import { render, staticRenderFns } from "./StatusMessageForm.vue?vue&type=template&id=1e330b1a"
import script from "./StatusMessageForm.vue?vue&type=script&lang=js"
export * from "./StatusMessageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports